import { render, staticRenderFns } from "./doximity.vue?vue&type=template&id=7e977c94&scoped=true&v-once=true"
import script from "./doximity.vue?vue&type=script&lang=js"
export * from "./doximity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e977c94",
  null
  
)

export default component.exports